import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';
import { urls } from '../../services/Server';

export default class AddCrypto extends Component {
  /*
    This component shows a form for adding a crypto currency to the portfolio.
  */

  render() {
    return (
      <Form horizontal method={'post'} action={urls.crypto}>
        <input name="cryptoId" type="hidden" value={this.props.cryptoId} />
        <Form.Group>
          <h4>Legg til i portefølje</h4>
        </Form.Group>
        <Form.Group controlId="stockholding">
          <Form.Label>Antall</Form.Label>
          <Form.Control
            required
            type="number"
            name="stockholding"
            step="0.0000000001"
            placeholder="Antall"
          />
        </Form.Group>

        <Form.Group controlId="totalprice">
          <Form.Label>Kostpris totalt</Form.Label>
          <Form.Control
            required
            type="number"
            name="totalprice"
            step="0.01"
            placeholder="Kostpris i NOK (total for alt)"
          />
        </Form.Group>

        <Form.Group controlId="date">
          <Form.Label>Dato inv.</Form.Label>
          <Form.Control type="date" name="date" placeholder="Dato investert" />
        </Form.Group>

        <Form.Group>
          <Button variant="success" type="submit">
            Legg til
          </Button>
        </Form.Group>
      </Form>
    );
  }
}

AddCrypto.propTypes = {
  cryptoId: PropTypes.number.isRequired
};
